export enum ErrorType {
  serverError = 1
}
